import React, { useEffect, useState } from "react";
import { supabase } from "../../../supabase";
import Header from "../Header";
import { Link } from "react-router-dom";
import { compressPdf } from "./CompressPdf";

function AdminPublications() {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({
    id: "",
    book: "",
    author: "",
    category: "",
    url: null,
  });

  const [editFile, setEditFile] = useState(null);
  const MAX_SIZE = 500 * 1024;

  useEffect(() => {
    fetchPublications();
  }, []);

  const fetchPublications = async () => {
    try {
      const { data, error } = await supabase
        .from("publications")
        .select("id, book, category, author, url")
        .order("category");

      if (error) throw error;
      setPublications(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (item) => {
    setEditData(item);
    setEditFile(null);
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const updatePublication = async () => {
    try {
      let fileUrl = editData.url;

      if (editFile) {
        let uploadFile = editFile;
        const ext = editFile.name.split(".").pop();
        const fileName = `${editData.id}.${ext}`;

        if (editFile.type === "application/pdf") {
          uploadFile = await compressPdf(editFile);
          if (uploadFile.size > MAX_SIZE) {
            throw new Error("PDF must be below 500 KB");
          }
        }

        // Remove old file if exists
        if (editData.url) {
          const oldFile = editData.url.split("/").pop();
          await supabase.storage.from("publications").remove([oldFile]);
        }

        // Upload new file
        const { error: uploadError } = await supabase.storage
          .from("publications")
          .upload(fileName, uploadFile, { upsert: true });

        if (uploadError) throw uploadError;

        const { data } = supabase.storage
          .from("publications")
          .getPublicUrl(fileName);

        fileUrl = data.publicUrl;
      }

      const { error } = await supabase
        .from("publications")
        .update({
          book: editData.book,
          author: editData.author,
          category: editData.category,
          url: fileUrl,
        })
        .eq("id", editData.id);

      if (error) throw error;

      setShowModal(false);
      fetchPublications();
    } catch (err) {
      alert(err.message || "Update failed");
    }
  };

  const deletePdf = async () => {
    try {
      if (!editData.url) return;

      const fileName = editData.url.split("/").pop();

      await supabase.storage.from("publications").remove([fileName]);

      await supabase
        .from("publications")
        .update({ url: null })
        .eq("id", editData.id);

      setEditData((prev) => ({ ...prev, url: null }));
      fetchPublications();

      alert("File deleted successfully");
    } catch (err) {
      alert("Failed to delete file");
    }
  };

  return (
    <main className="main-content" id="mainContent">
      <Header heading="Publications" />

      <Link className="btn btn-dark mb-3" to="/admin-add-publication">
        Add Publication
      </Link>

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Book</th>
            <th>Author</th>
            <th>Category</th>
            <th>Download</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : publications.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center text-danger">
                No publications found
              </td>
            </tr>
          ) : (
            publications.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.book}</td>
                <td>{item.author}</td>
                <td>
                  <span className="badge bg-dark">{item.category}</span>
                </td>
                <td>
                  {item.url ? (
                    <a href={item.url} target="_blank" rel="noreferrer">
                      Download
                    </a>
                  ) : (
                    <small className="text-muted">Not Available</small>
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => openEditModal(item)}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "#0006" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Publication</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <label>
                  Book name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control mb-2"
                  name="book"
                  value={editData.book}
                  onChange={handleChange}
                  placeholder="Book Name"
                />
                <label>
                  Author<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control mb-2"
                  name="author"
                  value={editData.author}
                  onChange={handleChange}
                  placeholder="Author"
                />
                <label>
                  Category<span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-control mb-2"
                  name="category"
                  value={editData.category}
                  onChange={handleChange}
                >
                  <option value="">--Select--</option>
                  <option value="Poetry">Poetry</option>
                  <option value="Story/Short-stories">
                    Story/Short-stories
                  </option>
                  <option value="Novel">Novel</option>
                  <option value="Drama">Drama</option>
                  <option value="Folksong">Folksong</option>
                  <option value="History">History</option>
                  <option value="Translation">Translation</option>
                  <option value="Kai alammo">Kai alammo</option>
                  <option value="Translation">Translation</option>
                  <option value="Speeches">Speeches</option>
                  <option value="Legend">Legend</option>
                  <option value="Grammar">Grammar</option>
                  <option value="Dictionary">Dictionary</option>
                  <option value="Proverb">Proverb</option>
                  <option value="Idiom Phrases">Idiom Phrases</option>
                  <option value="Rituals and Festivities">
                    Rituals and Festivities
                  </option>
                  <option value="Literary Magazine">Literary Magazine</option>
                  <option value="Souvenir">Souvenir</option>
                  <option value="Others">Others</option>
                </select>
                <label>PDF</label>
                <input
                  type="file"
                  className="form-control mb-2"
                  accept="application/pdf,image/*"
                  onChange={(e) => setEditFile(e.target.files[0])}
                />

                {editData.url && (
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() =>
                      window.confirm("Delete this file?") && deletePdf()
                    }
                  >
                    Delete File
                  </button>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={updatePublication}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default AdminPublications;
